import Article from './article';
import DayPass from './day-pass';
import GoConnect from './go-connect';
import Home from './home';
import News from './news';
import NewsArchive from './news-archive';
import NewsCategory from './news-category';
import NewsSubCategory from './news-sub-category';
import Page from './page';
import PropTypes from 'prop-types';
import Tickets from './tickets';
import ZooMap from './zoo-map';
import { zooSnaps } from 'config/go-connect';
import React, { Component } from 'react';

class Template extends Component {
    render() {
        const {
            activeCategories,
            data,
            featuredNews,
            globalFields,
            id,
            latestNews,
            listingPage,
            newsCategories,
            newsSubCategories,
            popularNews,
            type
        } = this.props;

        // 'type' is defined by the templateType() utility function
        switch (type) {
            case 'home':
                return <Home data={data} globalFields={globalFields}/>;
            case 'news':
                return (
                    <News
                        activeCategories={activeCategories}
                        data={data}
                        featuredNews={featuredNews}
                        latestNews={latestNews}
                        listingPage={listingPage}
                        newsCategories={newsCategories}
                        popularNews={popularNews} />
                );
            case 'news-archive':
                return <NewsArchive data={data} listingPage={listingPage} />;
            case 'news-category':
                return (
                    <NewsCategory
                        activeCategories={activeCategories}
                        data={data}
                        id={id}
                        listingPage={listingPage}
                        newsCategories={newsCategories}
                        newsSubCategories={newsSubCategories} />
                );
            case 'news-sub-category':
                return <NewsSubCategory data={data} id={id} listingPage={listingPage} />;
            case 'article':
                return <Article data={data} />;
            case 'tickets':
                return <Tickets data={data} />;
            case 'zoosnaps':
                return <GoConnect data={data} {...zooSnaps} />;
            case 'zoo-map':
                return <ZooMap data={data} globalFields={globalFields} />;
            case 'day-pass':
                return <DayPass data={data} />;
            case 'page':
            default:
                return <Page data={data} />;
        }
    }
}

Template.propTypes = {
    activeCategories: PropTypes.array,
    data: PropTypes.object,
    featuredNews: PropTypes.array,
    globalFields: PropTypes.object.isRequired,
    id: PropTypes.string,
    latestNews: PropTypes.array,
    listingPage: PropTypes.number,
    newsCategories: PropTypes.array,
    newsSubCategories: PropTypes.array,
    popularNews: PropTypes.array,
    type: PropTypes.string.isRequired
};

export default Template;
